export default {
  sectionList: [
    {
      subtitle: '',
      content: [
        {
          partType: 'string',
          value: 'この度、飛狼上海は2022年8月1日に下記住所に移転し業務を行うこととなりました。',
        },
        {
          partType: 'string',
          value:
            '今後も皆様のご期待にお応えするため、スタッフ一同、一層の努力を重ねる所存でございます。これからも変わらぬご支援、お引き立てのほど、よろしくお願いいたします。',
        },
        {
          partType: 'string',
          value:
          // eslint-disable-next-line max-len
            "<ul style='list-style-position: inside; padding-left: 1em;'><li>会社名：飛狼数碼（上海）有限公司</li><li>移転先：〒200002 上海市黄浦区河南南路16号中匯大厦2階</li></ul>",
        },
      ],
    },
    {
      subtitle: '',
      content: [
        {
          partType: 'string',
          value: 'お近くにお越しの際は、ぜひお立ち寄りください。',
        },
        {
          partType: 'string',
          // eslint-disable-next-line max-len
          value: "<strong>お問い合わせ：</strong><br>飛狼数碼（上海）有限公司　吉澤 克巳<br>メール：<a href='mailto:info@fenrir-inc.com.cn'>info@fenrir-inc.com.cn</a>",
        },
      ],
    },
  ],
};
